/**
 * @generated SignedSource<<16c73ccf3982bca1cf2f614dba33dfe5>>
 * @relayHash 3d2c5ddeb85976376bf23644a86ec8aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67440c6686cbb6e5d580c5933c5b60b037aaabee039dcba07e13519ee974cdb0

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type spotlightTourContainer_setSpotlightTourEnabledMutation$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type spotlightTourContainer_setSpotlightTourEnabledMutation$data = {
  readonly jira: {
    readonly userPreferences: {
      readonly setNaturalLanguageSpotlightTourEnabled: {
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type spotlightTourContainer_setSpotlightTourEnabledMutation = {
  response: spotlightTourContainer_setSpotlightTourEnabledMutation$data;
  variables: spotlightTourContainer_setSpotlightTourEnabledMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraUserPreferencesMutation",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isEnabled",
                "variableName": "isEnabled"
              }
            ],
            "concreteType": "JiraNaturalLanguageSearchSpotlightTourEnabledMutationPayload",
            "kind": "LinkedField",
            "name": "setNaturalLanguageSpotlightTourEnabled",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "success"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "spotlightTourContainer_setSpotlightTourEnabledMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "spotlightTourContainer_setSpotlightTourEnabledMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "67440c6686cbb6e5d580c5933c5b60b037aaabee039dcba07e13519ee974cdb0",
    "metadata": {},
    "name": "spotlightTourContainer_setSpotlightTourEnabledMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3f359c84a909e0fee178266828c63fb5";

export default node;
